import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import ShortcutLink from "../common/ShortcutLink";
import {UserContext} from "../common/UserContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import ButtonSelect from "../common/ButtonSelect";
import ListItemTestResultStudent from "../common/ListItemTestResultStudent";
import {BrandContext} from "../common/BrandContext";
import Button from "../common/Button";
import GoToButtonSection from "../components/GoToButtonSection";

const StudentTestResultsDashboardWidget = props => {
    const [testResults, setTestResults] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [testPurpose, setTestPurpose] = useState();
    const [testPurposes, setTestPurposes] = useState([]);
    const {user, setUser} = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const brandConfig = useContext(BrandContext);

    const testPurposesAll = [
        {value: 'ALL', label: 'All'},
        {value: 'TEST', label: 'Test'},
        {value: 'DIAGNOSTIC_TEST', label: 'Diagnostic'},
        {value: 'EXAM', label: 'Exam'}
    ];

    const testPurposesDiagnostic = [
        {value: 'ALL', label: 'All'},
        {value: 'TEST', label: 'Test'},
        {value: 'DIAGNOSTIC_TEST', label: 'Diagnostic'}
    ];

    const testPurposesExam = [
        {value: 'ALL', label: 'All'},
        {value: 'TEST', label: 'Test'},
        {value: 'EXAM', label: 'Exam'}
    ];

    useEffect(() => {
        if (brandConfig.enableExams && brandConfig.enableDiagnosticTests) {
            setTestPurpose('DIAGNOSTIC_TEST');
            setTestPurposes(testPurposesAll);
        } else if (brandConfig.enableDiagnosticTests) {
            setTestPurpose('DIAGNOSTIC_TEST');
            setTestPurposes(testPurposesDiagnostic);
        } else if (brandConfig.enableExams) {
            setTestPurpose('ALL');
            setTestPurposes(testPurposesExam);
        } else {
            setTestPurpose('TEST');
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        if (user.userId !== undefined) {
            axios.get('/web/ui/test/userTestResults', (testPurpose !== 'ALL' ? {params: {testPurpose: testPurpose}} : {}))
                .then(response => {
                    setTestResults(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [testPurpose]);

    const handleTestPurposeChange = selectedOption => {
        setTestPurpose(selectedOption.value);
    }

    const openTestResultFromDashboard = (testAssignmentId) => {
        window.location.href = '/controlCentre/studentTestResult.action?testAssignmentId=' + testAssignmentId;
    }

    return (
        <>
            {brandConfig.use2025Dashboard &&
                <h2>My {brandConfig.testName.toLowerCase()} results</h2>
            }
            <DashboardWidget
                title={!brandConfig.use2025Dashboard &&
                    <div className="ch-dashboard-title-with-icon">
                        <svg className="ch-icon-medium" viewBox="0 0 128 128">
                            <use href="#tests-icon"></use>
                        </svg>
                        <span>My {brandConfig.testsName.toLowerCase()} results</span>
                    </div>
                }
                headerActions={
                    <>
                        {(brandConfig.enableExams || brandConfig.enableDiagnosticTests) &&
                            <ButtonSelect title="Type" size="small" options={testPurposes} value={testPurpose !== undefined ? testPurposes.find(o => o.value === testPurpose) : 'ALL'} onChange={handleTestPurposeChange}/>
                        }
                    </>
                }
                isLoading={isLoading}
            >
                <div className={'ch-dashboard-blk-body'}>
                    {testResults.length > 0 &&
                        <table className={'ch-dashboard-widget-table ch-table'}>
                            <thead>
                                <tr>
                                    <th>Test name</th>
                                    <th>Assigned</th>
                                    <th>Status</th>
                                    <th>Result</th>
                                    <th>Test type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {testResults.map((testResult, index) => (
                                    <ListItemTestResultStudent key={testResult.testResultId} testResult={testResult}
                                                               onClickDiagnosticTest={() => {brandConfig.useStudentAssessmentReactUI ? loadShortcutByUrl('/web/ui/view/test/studentTestAssignments',null,'results') : loadShortcutByUrl('/controlCentre/showStudentTests.action');}}
                                                               onClick={() => {openTestResultFromDashboard(testResult.testAssignmentId)}} />
                                ))}
                            </tbody>
                        </table>
                    }
                    {testResults.length == 0 &&
                        <div className="ch-list-item-disabled">No assigned tests</div>
                    }
                </div>
                <GoToButtonSection buttonText={'Go to all test results'} onClick={() => brandConfig.useStudentAssessmentReactUI ? loadShortcutByUrl('/web/ui/view/test/studentTestAssignments',null,'results') : loadShortcutByUrl('/controlCentre/showStudentTests.action')} />
            </DashboardWidget>
        </>
    )
}

export default StudentTestResultsDashboardWidget;